import { createSlice } from '@reduxjs/toolkit'

interface ModelState {
  showAnnotations: boolean
}

const initialState: ModelState = {
  showAnnotations: false,
}

const modelSlice = createSlice({
  name: 'model',
  initialState,
  reducers: {
    handleAppearanceUpdate(state, action) {
      const { showAnnotations } = action.payload

      state.showAnnotations = showAnnotations
    },
  },
})

export const { handleAppearanceUpdate } = modelSlice.actions

export default modelSlice.reducer
